<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>All Warehouse Locations</h2>

    <div>
      <button class='btn btn-secondary' routerLink='/warehousing/locations/new'><i class="fas fa-plus"></i> New</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/locations/labels'><i class="fas fa-print"></i> Print Labels</button>&nbsp;
    </div>
  </div>
  <br />

  <div class="form-row">
    <div class="form-group col-md-4">
      <label>Warehouse</label>
      <select class='form-control' (change)='this.onWarehouseChanged($event.target.value)'>
        <option value='-1'>All warehouses</option>
        @for (item of this.warehouses; track item) {
          <option [value]='item.id' [selected]='this.selectedWarehouseId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
  </div>
  <br />

  <app-grid
    entity='warehouse-location'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [relationships]='this.relationships'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
    sortColumn='aisle'
    sortDirection='asc'
  ></app-grid>
</div>
